(function(angular){
    'use strict';

    angular.module('onvio.reports', [
        'onvio.reports.firmManagementReports.FirmManagementReportsListController',
        'onvio.reports.firmManagementReports.FirmManagementReportsOptionsController',
        'bluemoon.reports.components',
        'bluemoon.accounting.components.ClientDashboard'
    ]);
})(window.angular);
